import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { REPORT_GROUPS_QUERY_KEY } from './useInfiniteReportGroups';
import { REPORT_GROUP_ASSETS_QUERY_KEY } from './useListReportGroupAssets';

export const useDeleteReportGroup = ({
  reportId,
  groupId,
  onSuccess,
  onError,
}: {
  reportId: string;
  groupId: string;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await api.reports.deleteReportGroup(tenantId, reportId, groupId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REPORT_GROUPS_QUERY_KEY] });
      queryClient.resetQueries({ queryKey: [REPORT_GROUP_ASSETS_QUERY_KEY, { groupId }], exact: false });
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error.message || 'Failed to delete group');
    },
  });

  return {
    mutate,
    isPending,
  };
};
